import I18n from 'i18n-js';
import React from 'react';

export const SCORE_CONTAINER_CLASS_NAME = 'slide-show-score-variable';

type TotalSlideShowScoreHtmlType = {
  score?: number;
  locale?: string;
  snippetNum?: number;
  style?: string;
};

export const totalSlideShowScoreHtml = ({ style, score, locale, snippetNum } : TotalSlideShowScoreHtmlType): string => {
  const scoreString = score ?? `[${I18n.t('score', { locale }).toLowerCase()}]`;
  const pointsString = I18n.t('points', { locale }).toLowerCase();

  // <pre> and <br> tags introduce bugs with froala formating,
  // so we use white-space: pre style instead with a \n character
  const elementContent = `${locale === 'en' ? 'Score' : 'Puntuación'}:\n${scoreString} ${pointsString}`;

  return (
    `&#8203;<span 
    class=${SCORE_CONTAINER_CLASS_NAME} 
    contenteditable="false" 
    data-text-variable-id=${snippetNum} 
    ${style ? `style="${style}"` : ''}
    >${elementContent}</span><br/>`
  );
};

type TotalSlideShowScoreCallbackType = {
  e: React.MouseEvent<HTMLButtonElement>,
  editorInstance: any,
  htmlSnippets: {
    htmlEn: string,
    htmlEs: string,
  }
  locale: 'en' | 'es',
};

export const totalSlideShowScoreCallback = ({
  e,
  editorInstance,
  locale,
  htmlSnippets,
} : TotalSlideShowScoreCallbackType) => {
  e.preventDefault();
  e.stopPropagation();

  const html = locale === 'en' ? htmlSnippets.htmlEn : htmlSnippets.htmlEs;
  editorInstance.html.insert(html);
  editorInstance.undo.saveStep();
};

export const textVariableEnableEdit = (editorInstance: any) => {
  const editor = editorInstance.el as HTMLElement;
  if (!editor) return;

  const scoreElements = editor.querySelectorAll(`.${SCORE_CONTAINER_CLASS_NAME}`);
  scoreElements.forEach((element) => {
    element.setAttribute('contenteditable', 'true');
  });
};

export const textVariableDisableEdit = (editorInstance: any) => {
  const editor = editorInstance.el as HTMLElement;
  if (!editor) return;

  const scoreElements = editor.querySelectorAll(`.${SCORE_CONTAINER_CLASS_NAME}`);
  scoreElements.forEach((element) => {
    element.setAttribute('contenteditable', 'false');
  });
};
